import { createStore as createZustandStore } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import type { Shape } from "../../sketching/entities/_base/Shape";

type LabelsDisplayMode = "off" | "all" | "selected";

type Workspace3DStoreState = {
	tools: {
		activeTool: string | null;

		highlightedShape: Shape | null; // Hover
		selectedShape: Shape | null;
		selectedEdgeIndices: Array<number>; // Selected edges of selected object

		nameLabelsDisplayMode: LabelsDisplayMode;
		dimensionLabelsDisplayMode: LabelsDisplayMode;
	};
	cursor: {
		isSnappingEnabled: boolean;
	};
};

const INITIAL_STATE: Workspace3DStoreState = {
	tools: {
		activeTool: null,

		highlightedShape: null,
		selectedShape: null,

		nameLabelsDisplayMode: "all",
		dimensionLabelsDisplayMode: "all",

		selectedEdgeIndices: [],
	},
	cursor: {
		isSnappingEnabled: false,
	},
};

function createStore() {
	return createZustandStore(subscribeWithSelector(() => INITIAL_STATE));
}

export type { LabelsDisplayMode, Workspace3DStoreState };
export { createStore };
